module.exports = __webpack_public_path__ + "static/pac-man-4e3736ff8bb6b153bbcea084c4bb6392.jpg";